// A compact from/to date filter. `value` is { from, to } (yyyy-mm-dd strings);
// onChange receives the next {from,to}. Empty strings mean "unbounded".
function PaletteDateRange({ value = {}, onChange }) {
  const set = (key) => (event) => onChange({ ...value, [key]: event.target.value })

  return (
    <div className="palette-daterange">
      <input type="date" className="palette-date" value={value.from || ''} onChange={set('from')} />
      <span className="palette-date-sep">–</span>
      <input type="date" className="palette-date" value={value.to || ''} onChange={set('to')} />
    </div>
  )
}

export default PaletteDateRange
